// MOCK DATA - Live Sports for the hidden /fat page.
// NOTE: Real live sports streaming is not possible; these link to YouTube
// highlight / live sport videos shown inside an in-app player.

export const liveNow = [
  {
    id: 'l1',
    title: 'Champions League: Real Madrid vs Man City',
    league: 'UEFA Champions League',
    sport: 'Football',
    minute: "67'",
    score: '2 - 1',
    thumb: 'https://images.unsplash.com/photo-1522778119026-d647f0596c20?w=1200&q=80',
    youtube: 'J6_Km5tabaU',
    viewers: '3.2M watching',
  },
  {
    id: 'l2',
    title: 'NBA Finals: Lakers vs Celtics',
    league: 'NBA',
    sport: 'Basketball',
    minute: 'Q3 04:12',
    score: '78 - 74',
    thumb: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?w=1200&q=80',
    youtube: 'XEQ9zBdQ6cU',
    viewers: '1.8M watching',
  },
  {
    id: 'l3',
    title: 'Formula 1: Monaco Grand Prix',
    league: 'Formula 1',
    sport: 'Motorsport',
    minute: 'Lap 42/78',
    score: 'P1 VER',
    thumb: 'https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=1200&q=80',
    youtube: 'Gjrjb3Er2FU',
    viewers: '2.5M watching',
  },
];

export const upcoming = [
  {
    id: 'u1',
    title: 'Wimbledon Final: Alcaraz vs Djokovic',
    sport: 'Tennis',
    time: 'Today, 18:00',
    thumb: 'https://images.unsplash.com/photo-1595435934249-5df7ed86e1c0?w=1200&q=80',
    youtube: 'wQ82D2n2tI0',
  },
  {
    id: 'u2',
    title: 'Premier League: Arsenal vs Liverpool',
    sport: 'Football',
    time: 'Today, 20:30',
    thumb: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?w=1200&q=80',
    youtube: 'HqQ3rt0Vf9U',
  },
  {
    id: 'u3',
    title: 'UFC 300: Main Card',
    sport: 'MMA',
    time: 'Tomorrow, 03:00',
    thumb: 'https://images.unsplash.com/photo-1544117519-31a4b719223d?w=1200&q=80',
    youtube: 'rgdUP5Uz-8Q',
  },
  {
    id: 'u4',
    title: 'The Ashes: England vs Australia',
    sport: 'Cricket',
    time: 'Tomorrow, 11:00',
    thumb: 'https://images.unsplash.com/photo-1531415074968-036ba1b575da?w=1200&q=80',
    youtube: 'Xh7iA5s2mYw',
  },
];

export const replays = [
  {
    id: 'r1',
    title: 'World Cup Final Highlights',
    sport: 'Football',
    duration: '12 min',
    thumb: 'https://images.unsplash.com/photo-1459865264687-595d652de67e?w=1200&q=80',
    youtube: 'v0GfWDb7wNo',
  },
  {
    id: 'r2',
    title: 'Super Bowl LVIII Best Plays',
    sport: 'American Football',
    duration: '15 min',
    thumb: 'https://images.unsplash.com/photo-1566577739112-5180d4bf9390?w=1200&q=80',
    youtube: 'DkVdWtEwFa4',
  },
  {
    id: 'r3',
    title: 'Tour de France Stage 12',
    sport: 'Cycling',
    duration: '9 min',
    thumb: 'https://images.unsplash.com/photo-1541625602330-2277a4c46182?w=1200&q=80',
    youtube: 'X8vB9jK2lQ0',
  },
  {
    id: 'r4',
    title: 'Olympic 100m Sprint Final',
    sport: 'Athletics',
    duration: '6 min',
    thumb: 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=1200&q=80',
    youtube: 'kh5nQI_ac00',
  },
];

export const profiles = [
  { id: 'p1', name: 'Alex', color: '#e50914', avatar: 'https://occ-0-1723-1722.1.nflxso.net/dnm/api/v6/K6hjPJd6cR6FpVELC5Pd6ovHRSk/AAAABTZ2zlLdBVC05fsd2YQAR43J6vB1NAUBOOrxt7oaFATxMhtdzlNZ846H3D8TVzP-Q_dHm7lgYypLU9J4qMk7Ck5Uvcv3g.png?r=e6e' },
  { id: 'p2', name: 'Sam', color: '#0073e6', avatar: 'https://occ-0-1723-1722.1.nflxso.net/dnm/api/v6/K6hjPJd6cR6FpVELC5Pd6ovHRSk/AAAABY5cwIbwHVLBrͤ.png' },
];